var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field"},[(_vm.label.length > 0)?_c('label',{staticClass:"label"},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_c('div',{staticClass:"flexrow"},_vm._l((_vm.options),function(option){return _c('span',{key:option.label,class:{
        'choice':true,
        'flexrow-item': true,
        'selected': _vm.selectedOption.value === option.value
      },on:{"click":function($event){return _vm.selectOption(option)}}},[_vm._v(" "+_vm._s(_vm.getOptionLabel(option))+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }